// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MarketTypeFromJSON, MarketTypeToJSON, } from './';
export function PostMarketAllocationFromJSON(json) {
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'percentWeight': !exists(json, 'percentWeight') ? undefined : json['percentWeight'],
        'marketId': !exists(json, 'marketId') ? undefined : json['marketId'],
        'marketName': !exists(json, 'marketName') ? undefined : json['marketName'],
        'marketType': !exists(json, 'marketType') ? undefined : MarketTypeFromJSON(json['marketType']),
    };
}
export function PostMarketAllocationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'description': value.description,
        'number': value.number,
        'percentWeight': value.percentWeight,
        'marketId': value.marketId,
        'marketName': value.marketName,
        'marketType': MarketTypeToJSON(value.marketType),
    };
}
